/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICookieValue, ICookieContext } from '@msdyn365-commerce/core';

export const GetCookie = (cookies: ICookieContext, cookieName: string): string | undefined => {
    const marketCookie = cookies.get(cookieName) as ICookieValue<string> | undefined;

    if (marketCookie && marketCookie.value && marketCookie.value.length > 0) {
        return marketCookie.value;
    } else {
        return undefined;
    }
};

export const SetCookie = (cookies: ICookieContext, value: string, cookieName: string, exp: number): void => {
    if (value) {
        cookies.set(cookieName, value, { path: '/', maxAge: exp });
    }
};
